<template>
  <div class="p-3">
    <b-row>
      <b-col v-if="hasTitle">
        <h5>
          {{ tableTitle }}
        </h5>
      </b-col>
      <b-col cols="1">
      </b-col>
      <b-col v-if="hasFilter">
        <b-form-group label="Φίλτρο Πίνακα" label-for="filter-input" label-cols-sm="4" label-align-sm="right"
                      label-size="md" class="mb-0">
          <b-input-group>
            <b-form-input id="filter-input" v-model="filter" type="search"
                          placeholder="Αναζήτηση"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Καθαρισμός</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col v-if="hasGenericFilter">
        <b-form-group
            label="Φίλτρο Πίνακα"
            label-for="filter-input"
            label-cols-sm="4"
            label-align-sm="right"
            label-size="md"
            class="mb-0"
        >
          <b-input-group>
            <b-form-input
                id="filter-input"
                v-model="genericFilter"
                type="search"
                placeholder="Αναζήτηση"
                v-on:keyup.enter="onGenericFilter()"
            />
            <b-input-group-append>
              <b-button @click="onGenericFilter()">Αναζήτηση</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col v-if="hasSpecificFilter">
        <b-form-group>
          <b-input-group>
            <b-form-input
                id="filter-year-input"
                v-model="specificFilterYear"
                type="search"
                placeholder="Έτος"
                maxLength="4"
                minLength="4"
                v-on:keyup.enter="onGenericFilter()"
            />
            <b-form-input
                id="filter-month-input"
                v-model="specificFilterMonth"
                type="search"
                placeholder="Μήνας"
                v-on:keyup.enter="onGenericFilter()"
            />
            <b-form-input
                id="filter-foreas-input"
                v-model="specificFilterForeas"
                type="search"
                placeholder="Φορέας"
                v-on:keyup.enter="onGenericFilter()"
            />
            <b-input-group-append>
              <b-button @click="onGenericFilter()">Αναζήτηση</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="hasContent">
      <b-col class="pt-2">
        <span v-html="tableContent"></span>
      </b-col>
    </b-row>
    <b-table :thead-class="hasHeader ? '' : 'd-none'"
             :striped="striped"
             :bordered="bordered"
             :borderless="borderless"
             :outlined="outlined"
             :small="small"
             :hover="hover"
             :dark="dark"
             :fixed="fixed"
             :foot-clone="footClone"
             :no-border-collapse="noCollapse"
             :items="tableItems"
             :fields="fields"
             :head-variant="headVariant"
             :table-variant="tableVariant"
             :filter="filter"
             :filter-included-fields="filterOn"
             :current-page="apiPagination ? 1 : currentPage"
             :per-page="perPage"
             :sort-by.sync="sortBy"
             :sort-desc.sync="sortDesc"
             :sort-direction="sortDirection"
             :select-mode="selectMode"
             :busy="isBusyC"
             responsive
             sticky-header
             stacked="md"
             show-empty
             @filtered="onFiltered"
             :sort-compare="sortCompare"
             ref="selectableTable"
             selectable
             @row-selected="onRowSelected"
             class="pt-2"
             :emptyFilteredText="emptyText"
             :emptyText="emptyText">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle mr-2" variant="primary"></b-spinner>
          <strong class="text-primary">Παρακαλώ περιμένετε...</strong>
        </div>
      </template>
      <!-- For invisible header I should use thClass = 'd-none' -->
      <template v-for="(field, index) in model.fields" v-slot:[`head(${field.key})`]="data">
        <span :key="index" v-html="data.label"/>
      </template>
      <!-- For invisible columns I should use tdClass = 'd-none' -->
      <template v-for="(field,index) in model.fields" v-slot:[`cell(${field.key})`]="data">
        <template v-if="field.component === 'actions' &&
                      (!field?.checkIfHide || (field.checkIfHide == true && (field.checkValueIfNullSecondLevel ? data.item[field.checkValueIfNull][field.checkValueIfNullSecondLevel]: data.item[field.checkValueIfNull])))">
          <b-button :key="'action-btn-'+index" :variant="field.variant"
                    class="mr-2 mt-2 animated-button"
                    @click.prevent.stop="$emit('handle-action', data.item)">
            <p class="h8 mb-0">
              <component class="pr-1" :is="field.icon"></component>
            </p>
          </b-button>
        </template>
        <template v-if="field.component === 'index'">
          <span :key="index" v-if="field.className" :class="field.className"> {{ data.index + 1 }}</span>
          <span :key="index" v-else> {{ data.index + 1 }} </span>
        </template>
        <template v-if="field.component === 'b-form-datepicker'">
                    <span :key="index" v-if="field.className" :class="field.className"> {{
                        callFormatDate(data.value)
                      }}</span>
          <span :key="index" v-else> {{ callFormatDate(data.value) }} </span>
        </template>
        <template v-else-if="field.component === 'b-form-select'">
                    <span :key="index" v-if="field.className" :class="field.className"> {{
                        !isEmpty(data.value[field.text]) ? data.value[field.text] : field?.options?.filter((f) => f.value == data.value)?.[0]?.text ?? data.value
                      }}</span>
          <span :key="index" v-else> {{
              !isEmpty(data.value[field.text]) ? data.value[field.text] : field?.options?.filter((f) => f.value == data.value)?.[0]?.text ?? data.value
            }} </span>
        </template>
        <template v-else-if="field.component === 'b-form-select-datalist'">
                    <span :key="index" v-if="field.className" :class="field.className"> {{
                        data.value[field.text]
                      }}</span>
          <span :key="index" v-else> {{ data.value[field.text] }} </span>
        </template>
        <template v-else-if="field.component === 'b-form-checkbox'">
                    <span :key="index" v-if="field.className" :class="field.className"> {{
                        data.value
                      }}</span>
          <span :key="index" v-else> {{ data.value ? 'Ναι' : 'Όχι' }} </span>
        </template>
        <template v-else>
            <span :key="index"
                  v-if="field.className && (field.classEnable === data.value || field.classEnable === true )"
                  :class="field.className"> {{ data.value }}</span>
          <span :key="index" v-else> {{ data.value }} </span>
        </template>
      </template>
      <template #empty="scope">
        <div class="text-center"> {{ scope.emptyText }}</div>
      </template>
      <template #cell(index)="data">
        {{ (data.index + 1) + (perPage * (currentPage - 1)) }}
      </template>
      <template #cell(name)="row">
        {{ row.value.first }} {{ row.value.last }}
      </template>
    </b-table>
    <template v-if="!isInternal">
      <b-row no-gutters class="row-custom-actions">
        <template
            v-if="withCustomActions === ButtonTableTypeEnum.DEFAULT || withCustomActions === ButtonTableTypeEnum.MIXED">
          <b-col class="mr-auto p-2">
            <b-button v-if="supportDelete" :disabled="selected.length == 0" variant="danger"
                      class="mr-2 mt-2 animated-button" @click="onDeleteForm(selected[0])">
              <p class="h8 mb-0">
                <b-icon-trash class="pr-1"></b-icon-trash>
                Διαγραφή
              </p>
            </b-button>
            <b-button v-if="supportCreate" variant="success" class="mr-2 mt-2 animated-button"
                      @click="onCreateForm">
              <p class="h8 mb-0">
                <b-icon-plus-square-dotted></b-icon-plus-square-dotted>&nbsp;
                Προσθήκη
              </p>
            </b-button>
            <b-button v-if="supportEdit" :disabled="selected.length == 0" variant="info"
                      class="mr-2 mt-2 animated-button" @click="onEditForm(selected[0])">
              <p class="h8 mb-0">
                <b-icon-pencil class="pr-1"></b-icon-pencil>
                Επεξεργασία
              </p>
            </b-button>
            <template v-if="withCustomActions === ButtonTableTypeEnum.MIXED">
              <template v-for="(button, index) in manualButtons">
                <b-button :key="index" :variant="button.variant"
                          :disabled="button?.disable"
                          class="mr-2 mt-2 animated-button"
                          @click="$emit('handle-' + button.type + '-custom', selected[0])">
                  <p class="h8 mb-0">
                    <component class="pr-1" :is="button.icon"></component>
                    {{ button.label }}
                  </p>
                </b-button>
              </template>
            </template>
          </b-col>
        </template>
        <template v-if="withCustomActions === ButtonTableTypeEnum.MANUAL">
          <b-col class="mr-auto p-2 col-custom-actions">
            <template v-for="(button, index) in manualButtons">
              <b-button
                  v-if="Object.prototype.hasOwnProperty.call(button, 'support') ? button.support : true"
                  :key="index" :variant="button.variant"
                  class="mr-2 mt-2"
                  :disabled="button?.disable"
                  @click="$emit('handle-' + button.type + '-custom', selected[0])">
                <p class="h8 mb-0">
                  <component class="pr-1" :is="button.icon"></component>
                  {{ button.label }}
                </p>
              </b-button>
            </template>
          </b-col>
        </template>
        <b-col v-if="hasPagination" class="col-has-pagination">
          <b-row class="justify-content-center pt-2">
            <b-form-group label="Ανα σελίδα" label-for="per-page-select" label-cols-lg="auto"
                          label-align-lg="right"
                          label-size="sm" class="mb-0 pl-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
                             style="max-width: 80px"></b-form-select>
            </b-form-group>
          </b-row>
        </b-col>
        <template v-if="rightAlign">
          <b-col class="mr-auto col-right-align">
            <b-row align-h="end" class="mr-2">
              <template v-for="(button, index) in manualRightButtons">
                <b-button :key="index" :variant="button.variant"
                          class="mr-2 mt-2 animated-button"
                          :disabled="button?.disable"
                          @click="$emit('handle-' + button.type + '-custom', selected[0])">
                  <p class="h8 mb-0">
                    <component class="pr-1" :is="button.icon"></component>
                    {{ button.label }}
                  </p>
                </b-button>
              </template>
            </b-row>
          </b-col>
        </template>
        <b-col v-if="hasPagination && !rightAlign" align-self="end" xs="2" lg="auto" class="p-2 no-right-align-col">
          <b-pagination v-model="currentPage" :total-rows="totalTableRows" :per-page="perPage"
                        align="fill"></b-pagination>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col v-if="hasPagination && rightAlign" align-self="end" xs="2" lg="auto" class="p-2 right-align-col">
          <b-pagination v-model="currentPage" :total-rows="totalTableRows" :per-page="perPage"
                        align="fill"></b-pagination>
        </b-col>
      </b-row>
    </template>
    <template v-else>
      <b-row no-gutters>
        <b-col v-if="hasPagination" class="mr-auto p-2">
          <b-row :align-h="onAlignSelf()">
            <b-form-group label="Ανα σελίδα" label-for="per-page-select" label-cols-lg="auto"
                          label-align-lg="right"
                          label-size="sm" class="mb-0 pl-2">
              <b-form-select id="per-page-select" v-model="perPage" :options="pageOptions" size="sm"
                             style="max-width: 80px"></b-form-select>
            </b-form-group>
          </b-row>
        </b-col>
        <b-col v-if="hasPagination" align-self="end" xs="2" lg="auto" class="p-2">
          <b-pagination v-model="currentPage" :total-rows="totalTableRows" :per-page="perPage"
                        align="fill"></b-pagination>
        </b-col>
      </b-row>
      <b-button v-if="supportDelete" :disabled="selected.length == 0" variant="danger"
                class="mr-2 mt-2 animated-button" @click="onDeleteForm(selected[0])">
        <p class="h8 mb-0">
          <b-icon-trash class="pr-1"></b-icon-trash>
          Διαγραφή
        </p>
      </b-button>
      <b-button v-if="supportCreate" variant="orange" class="mr-2 mt-2 animated-button"
                @click="onCreateForm">
        <p class="h8 mb-0">
          <b-icon-plus-square-dotted></b-icon-plus-square-dotted>&nbsp;
          Προσθήκη
        </p>
      </b-button>
      <b-button v-if="supportEdit" :disabled="selected.length == 0" variant="info"
                class="mr-2 mt-2 animated-button" @click="onEditForm(selected[0])">
        <p class="h8 mb-0 animated-button">
          <b-icon-pencil class="pr-1"></b-icon-pencil>
          Επεξεργασία
        </p>
      </b-button>
    </template>
    <BaseBFormModal ref="modal" @handle-submit="onSubmit" @handle-delete="onDelete" @handle-valid="onValid"
                    :model="model" :hasHeader="hasFormModalHeader" :size="formModalSize"/>
  </div>
</template>

<script>

import {tableVisibility} from "@/util/ComponentUtils";
import {formatDateGRDefault} from "@/util/DateUtil";
import {isEmpty} from "@/util/Helpers";
import {ButtonTableTypeEnum} from "@/util/EnumUtil";

export default {
  name: "BaseBTable",
  props: {
    model: {
      default: () => {
      },
      require: true,
      type: Object
    },
    sortCompare: {
      default: () => {
      },
      require: false,
      type: Function
    },
    filterOn: {
      default: () => [],
      require: false,
      type: Array
    },
    items: {
      default: () => [],
      require: true,
      type: Array
    },
    tableTitle: {
      default: 'Όνομα Πίνακα',
      require: false,
      type: String
    },
    tableContent: {
      default: 'Περιοχόμενο subtitle για τον πίνακα',
      require: false,
      type: String
    },
    hasHeader: {
      default: true,
      require: false,
      type: Boolean
    },
    formModalSize: {
      default: () => 'lg',
      require: false,
      type: String
    },
    hasFormModalHeader: {
      default: () => false,
      require: false,
      type: Boolean
    },
    hasPagination: {
      default: true,
      require: false,
      type: Boolean
    },
    apiPagination: {
      default: false,
      require: false,
      type: Boolean
    },
    apiTotalRows: {
      default: 1,
      require: false,
      type: Number
    },
    hasFilter: {
      default: false,
      require: false,
      type: Boolean
    },
    hasGenericFilter: {
      default: false,
      require: false,
      type: Boolean
    },
    hasSpecificFilter: {
      default: false,
      require: false,
      type: Boolean
    },
    hasTitle: {
      default: true,
      require: false,
      type: Boolean
    },
    hasContent: {
      default: false,
      require: false,

    },
    isBusy: {
      default: false,
      require: false,
      type: Boolean
    },
    noCollapse: {
      default: true,
      require: false,
      type: Boolean
    },
    selectMode: {
      default: 'single',
      require: false,
      type: String
    },
    striped: {
      default: true,
      require: false,
      type: Boolean
    },
    bordered: {
      default: true,
      require: false,
      type: Boolean
    },
    borderless: {
      default: false,
      require: false,
      type: Boolean
    },
    outlined: {
      default: true,
      require: false,
      type: Boolean
    },
    small: {
      default: false,
      require: false,
      type: Boolean
    },
    hover: {
      default: true,
      require: false,
      type: Boolean
    },
    dark: {
      default: false,
      require: false,
      type: Boolean
    },
    fixed: {
      default: false,
      require: false,
      type: Boolean
    },
    footClone: {
      default: false,
      require: false,
      type: Boolean
    },
    /**
     * headVariant:
     *      'light',
     *       'dark'
     */
    headVariant: {
      default: null,
      require: false,
      type: String
    },
    /**
     *  tableVariants:
     *         'primary',
     *         'secondary',
     *         'info',
     *         'danger',
     *         'warning',
     *         'success',
     *         'light',
     *         'dark'
     */
    tableVariant: {
      default: null,
      require: false,
      type: String
    },
    withCustomActions: {
      default: ButtonTableTypeEnum.DEFAULT,
      require: false,
      type: String
    },
    withCustomButtons: {
      default: () => [],
      require: false,
      type: Array
    },
    withRightCustomButtons: {
      default: () => [],
      require: false,
      type: Array
    },
    isInternal: {
      default: false,
      require: false,
      type: Boolean
    },
    supportCreate: {
      default: true,
      require: false,
      type: Boolean
    },
    supportEdit: {
      default: true,
      require: false,
      type: Boolean
    },
    supportDelete: {
      default: true,
      require: false,
      type: Boolean
    },
    supportChange: {
      default: true,
      require: false,
      type: Boolean
    },
    generalButtonLabel: {
      default: '',
      require: false,
      type: String
    },
    rightAlign: {
      default: false,
      require: false,
      type: Boolean
    },
    generalButtonDisable: {
      default: true,
      require: false,
      type: Boolean
    },
  },
  watch: {
    perPage() {
      this.checkApiPagination();
    },
    currentPage() {
      this.checkApiPagination();
    },
    filter(val) {
      return !isEmpty(val) ? val.toString().toUpperCase() : val
    },
    tableItems() {
      this.init();
    },
    isBusy(cur) {
      return cur
    },
    deep: true
  },
  data() {
    return {
      currentPage: 1,
      currentIndex: 0,
      perPage: 10,
      pageOptions: [5, 10, 15, {value: 10000, text: "Όλα"}],
      filter: null,
      genericFilter: null,
      specificFilterYear: null,
      specificFilterMonth: null,
      specificFilterForeas: null,
      selected: [],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      customButtons: [
        {
          label: 'Προσθήκη',
          type: 'create',
          variant: 'orange',
          icon: 'b-icon-plus-square-dotted'
        },
        {
          label: 'Επεξεργασία',
          type: 'edit',
          variant: 'info',
          icon: 'b-icon-pencil-square'
        },
        {
          label: 'Διαγραφή',
          type: 'delete',
          variant: 'danger',
          icon: 'b-icon-trash'
        }
      ]
    }
  },
  beforeDestroy() {
    this.totalRows = null
    delete this.totalRows
    this.currentPage = null
    delete this.currentPage
    this.currentIndex = null
    delete this.currentIndex
    this.perPage = null
    delete this.perPage
    this.pageOptions = null
    delete this.pageOptions
    delete this.model
  },
  computed: {
    ButtonTableTypeEnum() {
      return ButtonTableTypeEnum
    },
    manualButtons() {
      return isEmpty(this.withCustomButtons) ? this.customButtons : this.withCustomButtons
    },
    manualRightButtons() {
      return isEmpty(this.withRightCustomButtons) ? this.customButtons : this.withRightCustomButtons
    },
    isBusyC() {
      return this.isBusy
    },
    totalTableRows() {
      return this.apiPagination ? Number(this.apiTotalRows) : Number(this.totalRows)
    },
    tableItems() {
      return this.init()
    },
    fields() {
      return tableVisibility(this.model.fields)
    },
    emptyText() {
      return 'Δεν βρέθηκαν εγγραφές.'
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return {text: f.label, value: f.key}
          })
    }
  },
  created() {
    if (this.apiPagination) {
      this.pageOptions = [5, 10, 15, 25]
    } else {
      this.pageOptions = [5, 10, 15, {value: 10000, text: "Όλα"}]
      this.totalRows = !isEmpty(this.items) ? this.items.length : 0;
    }
  },
  methods: {
    isEmpty,
    init() {
      this.model.fields.forEach(field => {
        if (Object.prototype.hasOwnProperty.call(field, 'tableValue')) {
          field[field['tableValue']] = field['tableValue']
          if (!isEmpty(this.items)) {
            this.items.forEach(x => {
              if (Object.prototype.hasOwnProperty.call(field, 'static')) {
                x[field['tableValue']] = x[field.desc]
              } else {
                x[field['tableValue']] = x[field.key][field.textField]
              }
            })
          }
        }
      })
      return this.items
    },
    callFormatDate(value) {
      return formatDateGRDefault(value);
    },
    checkApiPagination() {
      if (this.apiPagination) {
        this.$emit("update-pagination", this.currentPage, this.perPage, this.specificFilterYear, this.specificFilterMonth, this.specificFilterForeas);
      }

    },
    onSubmit(item) {
      if (!isEmpty(item)) {
        let result = this.$refs.modal.onValid(item)
        item.formResult.result = result.result
        item.formResult.errors = result.errors
        this.$emit("handle-submit", item);
      }
    },
    onDelete(item) {
      if (!isEmpty(item)) {
        this.$emit("handle-delete", item);
      }
    },

    onCreate() {
      this.$emit("handle-create", this.model.model.form);
    },

    onChange(item) {
      console.log('onChange-table')
      this.$emit("handle-change", item);
    },
    onCreateForm() {
      console.log('onCreateForm')
      this.$emit("handle-create", this.model.model.form)

      this.$nextTick(() => {
        this.$refs.modal.onCreate(this.model.model.form)
      })
    },

    onDeleteForm(item) {
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.openDeletePopUp(item, this.currentIndex)
    },

    onEditForm(item) {
      console.log('onEditForm')
      let index = this.tableItems.indexOf(item)
      if (this.selected.length > 0 && index !== -1) {
        this.currentIndex = index
      }
      this.$refs.modal.onEdit(item, this.currentIndex)
      this.$emit("handle-edit", item)
    },
    onRowSelected(item) {
      // if (item.length > 0) {
      this.selected = item
      this.$emit("handle-row-select", item);
      // }
    },
    onGenericFilter() {
      if (this.currentPage != 1) this.currentPage = 1;
      else this.checkApiPagination();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems)
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    onFiltering(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      // console.log(filteredItems.monthString.toUpperCase())
    },

    /* Checks the validity of the form */
    onValid(item) {
      // this.onEditFormInternal(item.formResult.form)
      let result = {result: false > 0, errors: []}
      try {
        if (!isEmpty(this.$refs.modal)) {
          result = this.$refs.modal.onValid(item)
        }
        return result
      } catch (e) {
        console.log(e)
        return result
      }
    },
    onAlignSelf() {
      return this.rightAlign === true ? "center" : "end"

    }
  }
}
</script>

<style>
/*.panel-heading {*/
/*  background: #fafafa;*/
/*  border-bottom: 2px solid #ececec;*/
/*  padding: 11px 20px 9px;*/
/*  position: relative;*/
/*}*/
/* Busy table styling */
table.b-table[aria-busy='true'] {
  opacity: 0.6;
}

/*.table.b-table > tbody > .table-active, .table.b-table > tbody > .table-active > td, .table.b-table > tbody > .table-active > th
{
  background-color: var(--info) ;
}*/

/*.animated-button {*/
/*  transition: opacity 1.5s;*/

/*}*/

/*.animated-button:hover {*/
/*  transform: scale(1.1);*/
/*  animation: bounce 0.4s;*/
/*  opacity: 0.8;*/
/*}*/

/*@keyframes bounce {*/
/*  0% { transform: scale(1); }*/
/*  50% { transform: scale(1.1); }*/
/*  100% { transform: scale(1.1); }*/
/*}*/
</style>
